import { useEffect, useState } from 'react';
import { FaUpload, FaTrash, FaEye, FaEyeSlash } from 'react-icons/fa';
import { supabase } from '../../lib/supabaseClient';
import { addGalleryImages, deleteGalleryImage, uploadImage, setVisible } from '../../lib/adminApi';

const GalleryManagementPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [progress, setProgress] = useState('');

  const load = async () => {
    setLoading(true);
    const { data } = await supabase.from('gallery').select('*').order('sort_order', { ascending: true });
    setItems(data || []);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const handleUpload = async (e) => {
    const files = [...(e.target.files || [])];
    if (!files.length) return;
    setBusy(true);
    try {
      const urls = [];
      for (let i = 0; i < files.length; i++) {
        setProgress(`Wysyłanie ${i + 1}/${files.length}...`);
        urls.push(await uploadImage(files[i], 'gallery'));
      }
      await addGalleryImages(urls);
      await load();
    } catch (err) { alert('Błąd: ' + err.message); }
    finally { setBusy(false); setProgress(''); e.target.value = ''; }
  };

  const handleDelete = async (item) => {
    if (!window.confirm('Usunąć to zdjęcie z galerii?')) return;
    try { await deleteGalleryImage(item.id); await load(); }
    catch (err) { alert('Błąd usuwania: ' + err.message); }
  };

  const toggleVisible = async (item) => {
    try { await setVisible('gallery', item.id, item.visible === false); await load(); }
    catch (err) { alert(err.message); }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <p className="text-gray-600">Zdjęć w galerii: <span className="font-semibold">{items.length}</span></p>
        <label className="cursor-pointer inline-flex items-center gap-2 bg-brand-accent text-white px-4 py-2 rounded-lg hover:opacity-90">
          <FaUpload /> {busy ? (progress || 'Wysyłanie...') : 'Dodaj zdjęcia'}
          <input type="file" accept="image/*" multiple className="hidden" onChange={handleUpload} disabled={busy} />
        </label>
      </div>

      {loading ? <p className="text-gray-500">Ładowanie...</p> : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
          {items.map((it) => {
            const hidden = it.visible === false;
            return (
            <div key={it.id} className="relative group rounded-lg overflow-hidden border border-gray-200 bg-white">
              <img src={it.image_url} alt="" className={`w-full h-32 object-cover ${hidden ? 'opacity-40' : ''}`} />
              {hidden && <span className="absolute bottom-1 left-1 text-xs bg-gray-800/80 text-white px-2 py-0.5 rounded-full">ukryte</span>}
              <button onClick={() => toggleVisible(it)} className="absolute top-2 left-2 bg-white/90 text-gray-700 rounded-full w-7 h-7 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow" title={hidden ? 'Pokaż na stronie' : 'Ukryj na stronie'}>
                {hidden ? <FaEyeSlash className="w-3 h-3" /> : <FaEye className="w-3 h-3" />}
              </button>
              <button onClick={() => handleDelete(it)} className="absolute top-2 right-2 bg-red-500 text-white rounded-full w-7 h-7 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" title="Usuń">
                <FaTrash className="w-3 h-3" />
              </button>
            </div>
            );
          })}
          {items.length === 0 && <p className="col-span-full p-6 text-gray-500">Galeria jest pusta.</p>}
        </div>
      )}
    </div>
  );
};

export default GalleryManagementPage;
